import { TCCF7_CONFIG } from './tccf7Constants.js';

/*-------------------------------------------------------------------------------

  シングルトン：フォームの状態管理（input / confirm / complete）

--------------------------------------------------------------------------------*/
export default class tccf7StateManager {
  static #instances = new Map();

  /*----------------------------------------
    インスタンスを取得する静的メソッド
  ------------------------------------------*/
  /**
   * @param {string} formId 
   */
  static getInstance(formId, form) {
    if (!this.#instances.has(formId)) {
      this.#instances.set(formId, new tccf7StateManager(formId, form));
    }
    return this.#instances.get(formId);
  }

   /**
   * @param {string} formId - フォームID
   */
  constructor(formId, form) {
    if (tccf7StateManager.#instances.has(formId)) {
      return tccf7StateManager.#instances.get(formId);
    }

    this.formId       = formId;
    this.form         = form;
    if( !this.form ) return;

    this.currentState = null; // 'input' | 'confirm' | 'complete'
    this.isVerified   = false;
    this.isSpam       = false;
    this.isValidate   = false;

    this.redirect     = false;

    const { STEP } = TCCF7_CONFIG.CLASSNAME;
    this.stateMap = {
      input:    `${STEP.INPUT}-${this.formId}`,
      confirm:  `${STEP.CONFIRM}-${this.formId}`,
      complete: `${STEP.COMPLETE}-${this.formId}`
    };
    this.commonStateMap = {
      input:    STEP.INPUT,
      confirm:  STEP.CONFIRM,
      complete: STEP.COMPLETE
    };


    this.setState('input');
  }

  /*----------------------------------------
    共通の通知メソッド（内部用）
  ------------------------------------------*/
  #notify(source = 'state') {
    const event = new CustomEvent('tccf7:statusUpdate', { 
      detail: { 
        formId: this.formId,
        source: source,
        state: this.currentState,
        isVerified: this.isVerified,
        isSpam: this.isSpam,
        isValidate: this.isValidate
      }
    });
    document.dispatchEvent(event);
  }

  /*----------------------------------------
    状態更新
  ------------------------------------------*/
  /**
   * @param {'input'|'confirm'|'complete'} nextState 
   */
  setState(nextState) {
    if (this.currentState === nextState || !this.stateMap[nextState]) return;
    this.currentState = nextState;
    if( !(this.redirect && nextState === 'complete') ) {
      const cmnStepClasses = Object.values(this.commonStateMap);
      document.body.classList.remove(...cmnStepClasses);
      document.body.classList.add(this.commonStateMap[nextState]);
      const allStepClasses = Object.values(this.stateMap);
      this.form.classList.remove(...allStepClasses);
      this.form.classList.add(this.stateMap[nextState]);
    }

    this.#notify('state');
  }

  /*----------------------------------------
    セット
  ------------------------------------------*/
  setVerified(verified) {
    if (this.isVerified === verified) return;
    this.isVerified = verified;
    this.#notify('isVerified');
  }
  setSpam(spam) {
    if (this.isSpam === spam) return;
    this.isSpam = spam;
    this.#notify('isSpam');
  }
  setValidate(validate) {
    if (this.isValidate === validate) return;
    this.isValidate = validate;
    this.#notify('isValidate');
  }

  /*----------------------------------------
    ショートカット・判定・取得
  ------------------------------------------*/
  getState()    { return this.currentState; }
  setInput()    { this.setState('input'); }
  setConfirm()  { this.setState('confirm'); }
  setComplete() { this.setState('complete'); }
  setRedirect(bool) { this.redirect = bool; }

  is(state)     { return this.currentState === state; }
  isInput()     { return this.is('input'); }
  isConfirm()   { return this.is('confirm'); }
  isComplete()  { return this.is('complete'); }
}